module.exports = __webpack_public_path__ + "static/media/banjo.77b70020.svg";